export class ProductCount {
  constructor(
    private readonly _web: number = 0,
    private readonly _store: number = 0
  ) {
    if (!Number.isInteger(_web) || _web < 0) {
      throw new Error("Web product count must be a positive integer");
    }
    if (!Number.isInteger(_store) || _store < 0) {
      throw new Error("Store product count must be a positive integer");
    }
  }

  get web(): number {
    return this._web;
  }

  get store(): number {
    return this._store;
  }
}
